import { Client } from "./_clientService";
import { downloadBlob } from "utils/downloadBlob";

async function getBanners(options: any) {
  try {
    let payload = {
      pageNo: options?.pageNo,
      limit: options?.pageSize,
      sortKey: "createdAt",
      sortDir: "ASC",
      search: options?.search,
      skipPagination: options?.skipPagination ?? false,
      archived: options?.archived ?? false,
    };
    let path = "/banner/list";
    const resp = await new Client({ path, payload }).post();

    return resp;
  } catch (error) {
    throw error;
  }
}

async function getBannerInfo(bannerId: any) {
  try {
    const resp = await new Client({
      path: "/banner/info",
      payload: {
        bannerId: bannerId,
      },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function createBanner(bannerDetails: any) {
  try {
    const resp = await new Client({
      path: "/banner/create",
      payload: bannerDetails,
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function updateBanner(bannerDetails: any, bannerId: any) {
  try {
    const resp = await new Client({
      path: "/banner/update",
      payload: { ...bannerDetails, _id: bannerId },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

export async function deleteBanner(bannerId: any) {
  const resp = await new Client({
    path: "banner/delete",
    payload: { bannerId },
  }).post();

  return resp;
}

export async function updateBannerStatus(bannerId: any) {
  const resp = await new Client({
    path: "/banner/update/status",
    payload: { bannerId },
  }).patch();

  return resp;
}

export async function copyHomeBanner(bannerId: any) {
  const resp = await new Client({
    path: `/banner/copy`,
    payload: { input: { bannerId } },
  }).post();

  return resp;
}

export { getBanners, getBannerInfo, createBanner, updateBanner };

export async function archiveBanners(ids: string[]) {
  const resp = await new Client({
    path: "/banner/archive",
    payload: { ids },
  }).post();
  return resp;
}

export async function unarchiveBanners(ids: string[]) {
  const resp = await new Client({
    path: "/banner/unarchive",
    payload: { ids },
  }).post();
  return resp;
}

/** Sets every listed banner on (`enabled: true`) or off; unlike the single status route it never toggles. */
export async function bulkUpdateBannerStatus(ids: string[], enabled: boolean) {
  const resp = await new Client({
    path: "/banner/bulk/status",
    payload: { ids, enabled },
  }).post();
  return resp;
}

export async function bulkDeleteBanners(ids: string[]) {
  const resp = await new Client({
    path: "/banner/bulk/delete",
    payload: { ids },
  }).post();
  return resp;
}

export async function validateBannerBulkUpload(file: File) {
  const formData = new FormData();
  formData.append("file", file);
  const resp = await new Client({
    path: "/banner/bulk/validate",
    payload: formData,
    isFormData: true,
  }).post();
  return resp;
}

export async function bulkCreateBanners(file: File) {
  const formData = new FormData();
  formData.append("file", file);
  const resp = await new Client({
    path: "/banner/bulk/create",
    payload: formData,
    isFormData: true,
  }).post();
  return resp;
}

export async function downloadBannerBulkTemplate() {
  await downloadBlob("/banner/bulk/template", "Bulk-Create-Banners-Template.xlsx");
}
